export default __webpack_public_path__ + "static/9e2103d53a06cda88ca70787943d2802.jpg";